import {NgModule} from '@angular/core';
import {LayoutPageComponent} from '@automata/layout/page/page.component';

const modules = [];

export const components = [
  LayoutPageComponent
];

export const dialogs = [];

export const services = [];

export const pipes = [];
export const directives = [];

export const declarations = [
  ...pipes,
  ...dialogs,
  ...components,
  ...directives
];

@NgModule({
  imports:         [
    ...modules
  ],
  declarations,
  providers:       [
    ...services
  ],
  entryComponents: [
    ...dialogs
  ],
  exports:         [
    ...declarations,
    ...modules
  ]
})
export class LayoutPageModule {
}
